// extracted by mini-css-extract-plugin
module.exports = {"headButton":"SubAdmins_headButton__3a5R4","section":"SubAdmins_section__kpmOF","headButtonIcon":"SubAdmins_headButtonIcon___7GkT"};